import api from "api/axios";

export const getVisitorsByCompany = (id, params = {}) =>
  api.get(`/visitors/company/${id}`, { params });


export const getVisitorAnalyticsByCompany = (id) =>
  api.get(`/visitors/analytics/${id}`);

export const sendBadgeReminder = async (payload) => {
  const res = await api.post(`/reminder/send-badge`, payload);
  return res.data;
};

export const sendUnpaidReminder = async (payload) => {
  const res = await api.post("/reminder/send-unpaid-reminder", payload);
  return res.data;
};

export const updateVisitorDetails = async (visitorId, payload) => {
  const response = await api.put(`/visitors/${visitorId}`, payload);
  return response.data;
};

export const toggleVisitorConfirmation = (visitorId, isConfirmed) => {
  const response =  api.patch(`/visitors/${visitorId}/confirm`, { isConfirmed });
  return response;
};